import { useRef, useState } from 'react';
import Volanta from '../Volanta';
import Form from './Form';
import AnimacionContacto from './Animacion';
import PopupWrapper from '../PopupWrapper';

const Hero = ({ contact, country_short_name, form, customer_services_complain, show_complains_tyc, id_type, localidades, distritos, provincias, departamentos }) => {
  const section = useRef(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <section
      ref={section}
      className="site-max relative w-full pt-145 pb-100 sm:pb-40 overflow-hidden"
    >
      <div className="site-grid">
        <div className="lg:col-start-2 col-span-4 sm:col-span-10 flex flex-col sm:flex-row items-start sm:items-center sm:pl-18">
          <div className="block pointer-events-none">
            <AnimacionContacto />
          </div>
          <div className="mb-30 sm:mb-0 sm:mr-60">
            <h2 className="title-2 text-40 sm:text-48 text-dark-cyan">
              <div className="mb-15 whitespace-nowrap">¡Estamos para</div>
              <div className="inline-block relative">
                ayudarte!
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                  <svg className="w-210 sm:w-[27.4rem] h-auto" fill="none" viewBox="0 0 274 74">
                    <rect
                      width="271.902"
                      height="71.902"
                      x="1.049"
                      y="1.049"
                      stroke="url(#paint0_linear_2388_12710)"
                      strokeWidth="2.098"
                      rx="35.951"
                    ></rect>
                    <defs>
                      <linearGradient
                        id="paint0_linear_2388_12710"
                        x1="310.064"
                        x2="-9.133"
                        y1="0"
                        y2="0"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#EE4424"></stop>
                        <stop offset="0.468" stopColor="#FD813E"></stop>
                        <stop offset="1" stopColor="#22CDC6"></stop>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </div>
            </h2>
          </div>
          <div className="pt-44 mb-50 sm:mb-0">
            <div className="w-16 h-1 bg-red mb-21"></div>
            <div className="max-w-[30rem]">
              <p className="p1 text-black-1 opacity-60">
                  { contact.description }
              </p>
            </div>
          </div>
        </div>
        <div style={{
          gridColumnStart: '5',
          width: '100%'
        }} className="col-span-4 md:col-start-5 md:col-span-2 lg:col-start-7 lg:col-span-5 relative sm:-top-21">
          <Form localidades={localidades} distritos={distritos} provincias={provincias} departamentos={departamentos} id_type={id_type} show_complains_tyc={show_complains_tyc} customer_services_complain={customer_services_complain} form={form} country_short_name={country_short_name} finish={() => setIsPopupOpen(true)} />
        </div>
      </div>

      <PopupWrapper
        colorButton="bg-cyan button-cyan"
        colorStep="bg-cyan"
        isOpen={isPopupOpen}
        setIsOpen={setIsPopupOpen}
        showSteps={false}
        text="Gracias por comunicarte con nosotros. En la brevedad uno de nuestros asesores se pondrá en contacto."
      />
    </section>
  );
};
export default Hero;
